"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCell = void 0;
const material_1 = require("@mui/material");
const TableCell_1 = require("../tableCell/TableCell");
const StyledCell = (0, material_1.styled)(TableCell_1.TableCell)(({ theme }) => ({
    '&': {
        height: '60px',
        padding: '0 16px',
    },
    '.header-box': {
        'align-items': 'center',
        'border-radius': '2rem',
        display: 'flex',
        gap: '2px',
        'padding-left': '12px',
        'padding-right': '4px',
        'padding-bottom': '4px',
        'padding-top': '4px',
        'margin-left': '-12px',
        'margin-right': '0',
        '&:hover': {
            cursor: 'default',
        },
    },
    '.right': {
        'flex-direction': 'row-reverse',
        'padding-left': '4px',
        'padding-right': '12px',
        'margin-left': '0',
        'margin-right': '-12px',
    },
    '.sort-button': {
        visibility: 'hidden',
        '&:hover': {
            'background-color': 'inherit',
        },
    },
    '.sorted': {
        '.sort-button': {
            visibility: 'visible',
            color: theme.palette.blue[500],
        },
        '.header-box': {
            '&:hover': {
                cursor: 'pointer',
            },
            'background-color': theme.palette.blue[100],
            color: theme.palette.blue[500],
        },
    },
    '.unsorted': {
        '.header-box:hover': {
            cursor: 'pointer',
            'background-color': theme.palette.gray[200],
            '.sort-button': {
                visibility: 'visible',
            },
        },
    },
}));
exports.StyledCell = StyledCell;
//# sourceMappingURL=HeaderCell.styles.js.map